// getListNotificationSaga
import { callApiServiceCommon } from './service-common';

const commonApi = process.env.REACT_APP_API_CRONJOB_SERVICE_SERVICE;
const appCode = process.env.REACT_APP_CODE;

const currencyApi =
  'https://api-v1-autoketing.autoketing.org/asset-production-autoketing/currency-convert/sdk/base_usd_currency.json?';

export function* getCurrencyRate() {
  const payload = {
    method: 'GET',
    url: `${currencyApi}`,
    params: {}
  };
  return yield callApiServiceCommon(payload);
}

export function* updateNotificationService(shop, id) {
  const payload = {
    method: 'POST',
    url: `${commonApi}/ak/update-notification`,
    params: {
      app_code: appCode,
      shop_domain: shop,
      notification_id: id,
      read_status: true
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getListNotificationService(shop) {
  const payload = {
    method: 'GET',
    params: {
      app_code: appCode,
      shop_domain: shop
    },
    url: `${commonApi}/ak/get-notification`
  };
  return yield callApiServiceCommon(payload);
}

export function* getNotificationDetailService(shop, id) {
  const payload = {
    method: 'GET',
    params: {
      app_code: appCode,
      shop_domain: shop,
      notification_id: id
    },
    url: `${commonApi}/ak/get-notification`
  };
  return yield callApiServiceCommon(payload);
}
